import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cd5f9c10")

_pushScopeId("data-v-cd5f9c10")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "division__group" }
const _hoisted_4 = {
  key: 0,
  class: "update__group"
}
const _hoisted_5 = {
  key: 1,
  class: "no-data"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, "Aucune équipe enregistrée", -1)
const _hoisted_7 = { class: "division--title" }
const _hoisted_8 = { class: "teams__group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamAdd = _resolveComponent("TeamAdd")
  const _component_TeamCard = _resolveComponent("TeamCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.canAddTeam)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_TeamAdd)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.sortedCategories.length)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedCategories, (division) => {
          return (_openBlock(), _createBlock("div", { key: division }, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", null, _toDisplayString(_ctx.divisionName(division)), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teamsInDivision[division], (team) => {
                return (_openBlock(), _createBlock(_component_TeamCard, {
                  key: team._id,
                  team: team,
                  rank: _ctx.teamRank(team),
                  stats: _ctx.teamStats(team)
                }, null, 8, ["team", "rank", "stats"]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
})